import { deepCloneLayer } from '@/editor/history/cloneUtils'
import type { EditorHistoryCommand } from '@/editor/history/types'
import { getMockupHistoryBridge } from '@/editor/history/mockupEditorBridge'
import type { AnimationLayer } from '@/types/animationLayer'

/**
 * 原子替换单图层快照并同步时间轴选中（避免 Composite 子命令顺序在撤销/重做不对称）。
 */
export class ReplaceLayerWithTimelineSelectionCommand implements EditorHistoryCommand {
  readonly label: string

  private readonly layerId: string

  private readonly beforeLayer: AnimationLayer

  private readonly afterLayer: AnimationLayer

  private readonly beforeLayerSel: string | null

  private readonly beforeClipSel: string | null

  private readonly afterLayerSel: string | null

  private readonly afterClipSel: string | null

  /**
   * @param layerId - 图层 id
   * @param beforeLayer - 变更前图层深拷贝
   * @param afterLayer - 变更后图层深拷贝
   * @param beforeLayerSel - 变更前选中图层 id
   * @param beforeClipSel - 变更前选中 clip id
   * @param afterLayerSel - 变更后选中图层 id
   * @param afterClipSel - 变更后选中 clip id
   * @param label - 描述
   */
  constructor(
    layerId: string,
    beforeLayer: AnimationLayer,
    afterLayer: AnimationLayer,
    beforeLayerSel: string | null,
    beforeClipSel: string | null,
    afterLayerSel: string | null,
    afterClipSel: string | null,
    label: string,
  ) {
    this.layerId = layerId
    this.beforeLayer = beforeLayer
    this.afterLayer = afterLayer
    this.beforeLayerSel = beforeLayerSel
    this.beforeClipSel = beforeClipSel
    this.afterLayerSel = afterLayerSel
    this.afterClipSel = afterClipSel
    this.label = label
  }

  /** @inheritdoc */
  revert(): void {
    const b = getMockupHistoryBridge()
    b.replaceLayer(this.layerId, deepCloneLayer(this.beforeLayer))
    b.selectedLayerId.value = this.beforeLayerSel
    b.selectedClipId.value = this.beforeClipSel
    b.syncLayerSelection()
  }

  /** @inheritdoc */
  redo(): void {
    const b = getMockupHistoryBridge()
    b.replaceLayer(this.layerId, deepCloneLayer(this.afterLayer))
    b.selectedLayerId.value = this.afterLayerSel
    b.selectedClipId.value = this.afterClipSel
    b.syncLayerSelection()
  }
}
